<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="detailInfo"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card">
        <el-tab-pane
          :label="$t('message.' + langItem.langCode)"
          v-for="(langItem, index) in detailInfo.langMaps"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Title </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.title'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="langItem.title"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Cover Image
                </label>
                <div class="col-sm-10">
                  <el-upload
                    class="upload-demo upload-image"
                    action="#"
                    multiple
                    :http-request="uploadFile"
                    :auto-upload="true"
                    accept=".png, .jpg , .jpeg"
                    :show-file-list="false"
                  > 
                    <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
                    <div class="input-group img-group">
                      <div class="text-center dropzone logo">
                        <div
                          class="addImage"
                          v-if="!detailInfo.frontCoverImg.fullFileUrl"
                          style="width: 100%; padding-top: 25px; color: #fff"
                        >
                          <a class="addImageIcon btn btn-primary btn-circle">
                            <i class="el-icon-upload2"></i>
                          </a>
                          <p class="text-primary m-t-sm font14 suggestFont">
                            <slot name="sizeHint"></slot>
                          </p>
                        </div>
                        <div class="editImage" v-if="detailInfo.frontCoverImg.fullFileUrl">
                          <div class="mask-bg"></div>
                          <img :src="detailInfo.frontCoverImg.fullFileUrl" />
                          <div class="icon-center">
                            <span class="edit-icon">
                              <i class="el-icon-edit"></i>
                            </span>
                            <p class="font14 font-white editFont">Modify</p>
                            <p
                              class="text-primary font-white m-t-sm font14 suggestFont"
                            >
                              <slot name="sizeHint"></slot>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-upload>
                  <el-form-item
                    :prop="'frontCoverImg.fullFileUrl'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-input
                      style="display:none"
                      v-model="detailInfo.frontCoverImg.fullFileUrl"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <!----->
              <div class="form-group">
                <div class="col-sm-7">
                  <draggable
                    class="sortable-list connectList0 agile-list"
                    style="max-height: 600px;overflow: auto;margin-bottom: 15px;"
                    v-model="detailInfo.files"
                    group="people"
                    @start="drag = true"
                    @end="drag = false"
                  >
                    <div
                      v-for="(task, index) in detailInfo.files"
                      :key="index"
                      class="dragObj"
                    >
                      <div style="padding: 5px" v-if="task.type == 1">
                        <span style="display: inline-block;">
                          {{index+1}}. Image Name: {{ task["fileUrl"] }}
                        </span>
                      </div>
                      <div style="padding: 5px" v-else>
                        <span style="display: inline-block;">
                          {{index+1}}. Video URL:  
                        </span>
                        <el-input 
                          v-model="task.fileUrl"
                        ></el-input>
                        <el-upload
                          v-if="!task.frontCoverImg"
                          class=""
                          style="margin-top:10px;"
                          action="#"
                          multiple
                          :http-request="(param)=>{addThumbnailImage(param,index)}"
                          :auto-upload="true"
                          accept=".png, .jpg , .jpeg"
                          :show-file-list="false"
                        >
                          <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
                          <el-button size="mini">Add Thumbnail Image</el-button>
                        </el-upload>
                        <div style="position: relative;margin-top:10px;" v-else>
                          <span style="display: inline-block;">
                            Thumbnail Image Name: {{ task["frontCoverImg"] }}
                          </span>
                          <a
                            class="pull-right btn btn-xs btn-white"
                            style="position: absolute;right: -60px;"
                            @click="deleteThumbnailImage(index)"
                            ><i class="el-icon-delete"></i>
                          </a>
                        </div>
                        
                      </div>
                      <a
                        class="pull-right btn btn-xs btn-white"
                        style="position: absolute;top: 10px;right: 10px;"
                        @click="deleteObj(detailInfo.files, index)"
                        ><i class="el-icon-delete"></i>
                      </a>
                    </div>
                  </draggable>
                  <div class="col-sm-12 text-right pad-b-15">
                    
                    <el-upload
                      class="upload-demo upload-image"
                      style="display: inline-block; padding-right: 15px;"
                      action="#"
                      multiple
                      :http-request="addImageEvent"
                      :auto-upload="true"
                      accept=".png, .jpg , .jpeg"
                      :show-file-list="false"
                    >
                      <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
                      <el-button
                        type="primary"
                        >Add Image</el-button>
                    </el-upload>
                    <el-button
                      type="primary"
                      @click="addVideoEvent"
                      >Add Video</el-button>
                  </div>
                </div>
                <div class="col-sm-5">
                  <el-carousel indicator-position="outside" height="420px" v-if="showSwiper">
                    <el-carousel-item v-for="(item,index) in detailInfo.files" :key="index">
                      <el-image
                        v-if="item.type ==1"
                        style="width: 100%;"
                        :src="item.fullFileUrl"
                        ></el-image>
                      <video
                        v-else
                        :src="item.fileUrl"
                        :poster="item.fullFrontCoverImg"
                        controls="controls"
                        style="width: 100%;"
                      ></video>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
               <!----->
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Description
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.description'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur'
                    }"
                  >
                    <ckeditor :editor="editor"  @ready="onReady" v-model="langItem.description" :config="editorConfig" ></ckeditor>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">J Coins (optional)</label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="jcoins"
                    :rules="{
                      required: false,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input-number v-model="detailInfo.jcoins" :min="0"></el-input-number>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">J Channel Tag </label>
                <div class="col-sm-10">
                  <div>
                    <el-select
                      :value="detailInfo.recommendedEventCategory"
                      multiple
                      ref="tagSelect"
                      @change="handleSelectTag($event,index)"
                      v-bind:placeholder="$t('message.PleaseSelect')"
                    >
                      <el-option
                        v-for="item in categoryList"
                        :key="item.categoryCode"
                        :label="item.categoryNameEn"
                        :value="item.categoryCode"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
                 <div class="form-group">
                <label class="col-sm-2 control-label">J Channel Sub-Category</label>
                <div class="col-sm-10">
                  <div>
                    <el-select
                      v-model="detailInfo.subCategory"
                      v-bind:placeholder="$t('message.PleaseSelect')"
                    >
                      <el-option
                        v-for="item in allCategoryByType"
                        :key="item.categoryCode"
                        :label="item.categoryNameEn"
                        :value="item.categoryCode"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Reward introduction (optional)</label>
                <div class="col-sm-10">
                  <div>
                    <el-select
                      v-model="detailInfo.giftId"
                      clearable
                      v-bind:placeholder="$t('message.PleaseSelect')"
                    >
                      <el-option
                        v-for="item in giftList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Quiz Selection (optional)
                </label>
                <div class="col-sm-10">
                    <el-input
                      v-model="detailInfo.quizUrl"
                      show-word-limit
                    ></el-input>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Schedule Time </label>
                <div class="col-sm-10">
                    <el-date-picker
                      v-model="period"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="to"
                      start-placeholder="Start Time"
                      end-placeholder="End Time"
                    >
                    </el-date-picker>
                </div>
              </div>
              <div class="form-group" >
                <label class="col-sm-2 control-label">
                  Status
                </label>
                <div class="col-sm-4">
                  <el-form-item 
                      prop="status"
                      :rules="{
                        required: false, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                    <el-select v-model="detailInfo.status" disabled v-bind:placeholder='$t("message.PleaseSelect")'>
                        <el-option 
                        v-for="item in statusObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <!-- <div class="form-group" >
                <label class="col-sm-2 control-label">
                  Ideas Score
                </label>
                <div class="col-sm-4">
                  <el-form-item 
                      prop="ideasScore"
                      :rules="{
                        required: false, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                    <el-input v-model="detailInfo.ideasScore"></el-input>
                  </el-form-item>
                </div>
              </div> -->
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button
                      type="primary"
                      @click="checkEvent()"
                      v-if="
                        (checkPermission('J Channel_EDIT') &&
                          $route.query.id) ||
                        (checkPermission('J Channel_LIST_ADD') &&
                          !$route.query.id)
                      "
                      >Save</el-button
                    >
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import draggable from "vuedraggable";
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
const upload = require('../upload')

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'Heading', 'bold', 'italic','underline','Link', 'bulletedList', 'numberedList' ],
          // The configuration of the editor.
      },
      detailInfo: {
        langMaps: [],
        status: 0,
        recommendedEventCategory:"",
        subCategory:"",
        parentId:0,
        frontCoverImg:{
          fullFileUrl:"",
          fileUrl:"",
        },
        files:[],
        quizUrl:"",
        jcoins:0,
        ideasScore:0
      },
      statusObj: [],
      period: [],
      categoryList:[],
      allCategoryByType:[],
      giftList:[],
      statusObj:[],
      showSwiper:true,
      uploadErr:false
    };
  },
  watch: {
    _language: function () {
      this.setObj();
    },
    files: {
      handler: function() {
        this.showSwiper = false;
        var self = this;
        setTimeout(function(){
          self.showSwiper = true;
        })
        this.$store.state.edit = true;
      },
      deep: true
    }
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
  },
  components: {
    draggable
  },
  created() {
    var obj = [];
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        title: "",
      });
    }
    this.$set(this.detailInfo, "langMaps", obj);
    this.init();
    this.getAllCategoryEvent();
    this.getAllCategoryByType()
    this.getGiftList();
  },
  mounted() {
    this.setBreadcrumbs()
  },
  methods: {
    onReady( editor )  {
        // Insert the toolbar before the editable area.
        editor.ui.getEditableElement().parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            editor.ui.getEditableElement()
        );
    },
    setObj: function () {
      
      this.statusObj = [
        {
          value: 0,
          label: "Draft"
        },
        {
          value: 1,
          label: "Pending approval"
        },
        {
          value: 2,
          label: "Pending Publish"
        },
        {
          value: 3,
          label: "Rejected"
        },
        {
          value: 4,
          label: "Suspended"
        },
        {
          value: 5,
          label: "Pending Suspend"
        },
        {
          value: 6,
          label: "Published"
        }
      ];
    },
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.eLearningDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if(data.data.result.beginDate){
          this.period = [data.data.result.beginDate,data.data.result.endDate]
        }
        delete data.data.result ['userId']
        if(data.data.result.recommendedEventCategory){
          data.data.result.recommendedEventCategory = data.data.result.recommendedEventCategory.split(',')
        }
        if(!data.data.result.frontCoverImg){
          data.data.result.frontCoverImg = {
            fullFileUrl:"",
            fileUrl:"",
          };
        }
        this.$set(this, "detailInfo", data.data.result);
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      }
      this.setObj();
    },
    async getAllCategoryEvent() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.getAllCategory;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.$set(this, "categoryList", data.data.result);
    },
     async getAllCategoryByType() {
      let obj = this.getAuthObj();
      obj.type = 1
      obj.code = this.detailInfo.subCategory
      obj.apiUrl = this.apiConfig.getAllCategoryByType;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.$set(this, "allCategoryByType", data.data.result);
    },
    async getGiftList() {
      let obj = this.getAuthObj();
      obj.pageIndex = 1;
      obj.pageSize = 1111111;

      obj.status = this.ACTIVE_STATUS;
      obj.sortName = "Order";
      obj.sortType = "DESC";
      obj.apiUrl = this.apiConfig.giftList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.$set(this, "giftList", data.data.result.gifts);
    },
    checkEvent: function () {
      this.$refs["detailInfo"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
                that.callDelete();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              },
            },
          ],
        });
      }
    },
    async submit() {
        let obj = this.getAuthObj();
        for (var key in this.detailInfo) {
          obj[key] = this.detailInfo[key];
        }
        if (this.period&&this.period.length) {
          obj.beginDate = this.period[0];
          obj.endDate = this.period[1];
        } else {
          obj.beginDate = "";
          obj.endDate = "";
        }
        obj.files.forEach((item,index)=>{
          item.sortOrder = index;
        })
        var data;
        obj.recommendedEventCategory = obj.recommendedEventCategory.join(',')
        obj.parentId = this.$route.query.parentId
        if (this.$route.query.id) {
          obj.id = this.detailInfo.id;
          obj.apiUrl = this.apiConfig.eLearningUpdate;
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.apiUrl = this.apiConfig.eLearningCreate;
          data = await this.$store.dispatch("apiEvent", obj);
        }
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {},
    async uploadFile(params) {
      if(!this.handleCheckUploadFileSize(params.file)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.detailInfo.frontCoverImg.type = 0;
      this.detailInfo.frontCoverImg.sortOrder = 0;
      this.detailInfo.frontCoverImg.fileUrl = data.data.result.url;
      this.detailInfo.frontCoverImg.fullFileUrl = data.data.result.showUrl;
    },
    async addThumbnailImage(params,index){
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      Object.assign(this.detailInfo.files[index],{
        frontCoverImg:data.data.result.url,
        fullFrontCoverImg:data.data.result.showUrl
      })
    },
    deleteThumbnailImage(index){
      Object.assign(this.detailInfo.files[index],{
        frontCoverImg:'',
        fullFrontCoverImg:''
      })
    },
    async addImageEvent(params){
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.detailInfo.files.push({
        type:1,
        fileUrl: data.data.result.url,
        fullFileUrl: data.data.result.showUrl,
      })
    },
    //TODO
    addVideoEvent(){
      this.detailInfo.files.push({
        type:2,
        fileUrl: "",
        frontCoverImg:"",
        fullFrontCoverImg:"",
        fullFileUrl: "",
      })
    },
    setBreadcrumbs: function() {
      if (this.$route.path == "/main/e-learningSubDetail") {
        var breadcrumbs = this.$route.meta.breadcrumbs.find(
          b => b.to == "/main/e-learningDetail"
        );
        if(breadcrumbs){
          breadcrumbs.to = "/main/e-learningDetail?id="+this.$route.query.parentId;
        }
      }
    },
    handleSelectTag(e,langIndex){
      this.$refs.tagSelect[langIndex].blur()
      if(!e.length) return
      if( e.length>1) this.detailInfo.recommendedEventCategory = [e[e.length-1]]
      else this.detailInfo.recommendedEventCategory = e
    },
    handleCheckUploadFileSize(file){
      const sizeKB = file.size/1024
      if(sizeKB>5120){
        this.uploadErr = true
        return false
      }else{
        this.uploadErr = false
        return true
      }
    }
  },
};
</script>
